import React from 'react';
import { TypographyListItem } from 'components/TypographyList';
import ActionStatus from './ActionStatus';
import { IApproverListItem } from './interfaces';

export const ApproverListItem: React.FC<IApproverListItem> = ({
  name,
  role,
  actionId,
  isPredicted,
  ...props
}) => {
  return (
    <TypographyListItem
      {...props}
      icon={isPredicted ? undefined : <ActionStatus actionId={actionId} />}
      type={'icon'}
    >
      {name || role}
    </TypographyListItem>
  );
};

export default ApproverListItem;
